/** Gestion du parc : concurrents IA, vente/liquidation de magasins, achat des murs. */
import { COMPANY_LOGOS } from '../data/companyLogos';

export const ENSEIGNES_CONCURRENTES = [
  { id: 'distrimax', nom: 'Distrimax', couleur: '#EF4444', initiale: 'D' },
  { id: 'hypernord', nom: 'HyperNord', couleur: '#F59E0B', initiale: 'H' },
  { id: 'galleria', nom: 'Galleria', couleur: '#8B5CF6', initiale: 'G' },
];
export const getEnseigne = (id) => ENSEIGNES_CONCURRENTES.find(e => e.id === id) || ENSEIGNES_CONCURRENTES[0];

/** Logo d'une enseigne concurrente : pioché parmi les logos préréglés que
 *  l'apprenant n'utilise pas (attribution stable par enseigne). */
export const logoEnseigne = (enseigneId, joueurLogoId = null) => {
  const libres = COMPANY_LOGOS.filter(l => l.id !== joueurLogoId);
  if (libres.length === 0) return null;
  const idx = ENSEIGNES_CONCURRENTES.findIndex(e => e.id === enseigneId);
  return libres[(idx >= 0 ? idx : 0) % libres.length];
};

/* Concurrence locale : −8 % de trafic, −12 % si le concurrent est là depuis 30 j+. */
export const concurrentDansVille = (retail, villeId) =>
  (retail?.concurrents?.implantations || []).find(i => i.villeId === villeId) || null;

export const malusConcurrence = (retail, villeId, totalDays) => {
  const imp = concurrentDansVille(retail, villeId);
  if (!imp) return 1;
  let m = totalDays - imp.jour >= 30 ? 0.88 : 0.92;
  if (imp.guerreFinJour && totalDays < imp.guerreFinJour) m -= 0.07;
  return m;
};

/* ── Valorisation ── */
export const estimationFonds = (m) => {
  const invest = Object.entries(m.ameliorations || {}).reduce((s, [, niv]) => s + niv * 800, 0);
  return Math.round((m.loyerMensuel || 0) * 8 + (m.surface || 80) * 45 + invest);
};
export const prixMurs = (m) => Math.round((m.loyerMensuel || 0) * 132); // ≈ 11 ans de loyer
export const DUREE_HYPOTHEQUE_MOIS = 180;
export const TAUX_HYPOTHEQUE = 0.042;
export const AMORT_MURS_MOIS = 300; // 25 ans
export const valeurMurs = (m, totalDays) =>
  m.murs ? Math.round(m.murs.prix * (1 + 0.02 * ((totalDays - m.murs.achatJour) / 360))) : 0;
export const dotationMensuelleMurs = (m) => (m.murs ? Math.round(m.murs.prix / AMORT_MURS_MOIS) : 0);

/* ── Offres d'achat du fonds ── */
const ACHETEURS = ['Groupe Vermeil', 'Indépendant local', 'Franchise Colibri', 'Family Office Arnaud', 'Réseau Boutik+'];
export const probaOffreJour = (ratio) => (ratio <= 0.9 ? 0.14 : ratio <= 1.1 ? 0.08 : ratio <= 1.4 ? 0.035 : 0.012);
export const genererOffre = (m, totalDays) => {
  const est = estimationFonds(m);
  const brut = Math.round(est * (0.85 + Math.random() * 0.22));
  return {
    montant: Math.min(brut, Math.round((m.vente?.prix || est) * 1.02)),
    acheteur: ACHETEURS[Math.floor(Math.random() * ACHETEURS.length)],
    expireJour: totalDays + 3,
    contre: false,
  };
};

/* Liquidation : 7 jours de vente spéciale (−40 %) avant fermeture sans indemnité. */
export const LIQUIDATION_JOURS = 7;
export const INDEMNITE_BAIL_MOIS = 3;
